import { boxShadows, colors, fontSizes } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { DeleteIcon, MoveIcon } from "./Styles"

export type ColumnStyle = "centered"

const cellHorizontalPadding = "0.25rem"

const thOrTd = css`
  padding: 0.125rem ${cellHorizontalPadding};
  border-bottom: thin solid transparent;
`

export const table = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-left: -${cellHorizontalPadding};
`

export const th = styled.th<{ $style?: string }>`
  ${thOrTd};
  font-size: ${fontSizes._12};
  font-weight: normal;
  color: ${colors.textLight};
  text-align: ${({ $style }) => ($style === "centered" ? "center" : "left")};
`
export const tr = styled.tr<{ isBeingDragged: boolean }>`
  :hover {
    background-color: ${colors.backgroundLightest};
    ${DeleteIcon}, ${MoveIcon} {
      visibility: visible;
    }
  }

  ${({ isBeingDragged }) =>
    isBeingDragged &&
    css`
      background-color: white;
      border-top: thin solid ${colors.borderLightest};
      border-bottom: thin solid ${colors.borderLightest};
      box-shadow: ${boxShadows.medium};
      transform: rotate(1.5deg);
    `}
`
export const td = styled.td<{ $style?: string }>`
  ${thOrTd};
  ${({ $style }) =>
    $style === "centered" &&
    css`
      text-align: center;
      & > * {
        display: flex;
        justify-content: center;
      }
    `}
`
export const tdDelete = styled.td`
  ${thOrTd};
  width: 2rem;
  padding: 0;
  position: relative;
`
export const tdMove = styled.td`
  ${thOrTd};
  width: 2rem;
  padding: 0;
  position: relative;
`

export const Footer = styled.div`
  margin-top: 0.25rem;
  margin-left: -${cellHorizontalPadding};
`
